
import React, { useEffect, useState } from 'react'
import { Grid, Menu, Button, Dropdown, Icon, Ref, Sticky, Container } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import LogoIcon from "../../../../../assets/icons/Logo"
import { useDispatch, useSelector } from "react-redux";
import { ChangeActiveTab, SetShowSearchBox } from "../../../../../redux/actions/mainActions"
import SearchBox from '../SearchBox/SearchBox';
import "./NavigationBar.css"
import LanguageHandler from '../../../components/LanguageHandler/LanguageHandler';

const NavigationBar = ({ }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const fixed = useSelector((state) => state.main.fixed)
    const showSearchBox = useSelector((state) => state.main.showSearchBox)
    const activeTab = useSelector((state) => state.main.activeTab)
    const isRtl = useSelector((state) => state.main.isRtl)

    const handleItemClick = (e, name) => {
        dispatch(ChangeActiveTab(name))
    }

    const searchHandler = () => {
        dispatch(SetShowSearchBox(true))
    }
    const handleScroll = () => {
        dispatch(SetShowSearchBox(false))

    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, [])
    const trigger = (
        <span>
            <Icon circular name="user circle" />
        </span>

    )

    return <Menu fixed={fixed ? 'top' : null} inverted={!fixed}
        secondary={true}
        className={fixed ? 'HomeNav bg-white p-0 m-0 justify-content-center' : 'HomeNav p-0 m-0 justify-content-center'}
    >
        <Container fluid>
            <Grid verticalAlign='middle' columns='equal' className="w-100 m-0">
                <Grid.Row className="p-0">
                    <Grid.Column>
                        <Menu.Item className="justify-content-center" position={isRtl ? 'left' : 'right'}>
                            <LogoIcon className="icon-2rem  p-1" color={fixed ? 'var(--main-red)' : '#fff'} />
                        </Menu.Item>
                    </Grid.Column>
                    {
                        fixed === true ?
                            <Grid.Column>
                                <Menu.Item className="justify-content-center">
                                    <Button size='huge' onClick={() => searchHandler()} className={` rounded-50 w-70  align-items-center justify-content-between ${showSearchBox === true ? "d-none" : "d-inline-flex"}`} basic>
                                        {t(`home:${activeTab}`)}
                                        <Icon name='search' circular className="text-white bg-pink m-0" />
                                    </Button>
                                </Menu.Item>
                                <Grid.Row className="d-flex flex-row align-items-center justify-content-center">
                                    <Menu.Item
                                        className="justify-content-center"
                                        name={t("home:SearchRealState")}
                                        active={activeTab === 'SearchRealState'}
                                        className={showSearchBox === true ? "" : "d-none"}
                                        onClick={(e) => handleItemClick(e, 'SearchRealState')}
                                    />
                                    <Menu.Item
                                        className="justify-content-center"
                                        name={t("home:SearchResidence")}
                                        active={activeTab === 'SearchResidence'}
                                        className={showSearchBox === true ? "" : "d-none"}
                                        onClick={(e) => handleItemClick(e, 'SearchResidence')}
                                    />
                                </Grid.Row>

                            </Grid.Column>

                            : <Grid.Column>
                                <Grid.Row className="d-flex flex-row align-items-center justify-content-center">
                                    <Menu.Item
                                        className="justify-content-center"
                                        name={t("home:SearchRealState")}
                                        active={activeTab === 'SearchRealState'}
                                        onClick={(e) => handleItemClick(e, 'SearchRealState')}
                                    />
                                    <Menu.Item
                                        className="justify-content-center"
                                        name={t("home:SearchResidence")}
                                        active={activeTab === 'SearchResidence'}
                                        onClick={(e) => handleItemClick(e, 'SearchResidence')}
                                    />
                                </Grid.Row>

                            </Grid.Column>

                    }

                    <Grid.Column>
                        <Menu.Item className="justify-content-center" position={isRtl ? 'right' : 'left'}>
                            <LanguageHandler />

                            <Button className="m-05 boxshadow-none" inverted={!fixed} basic>Become a Host</Button>


                            <Dropdown
                                icon="bars"
                                trigger={trigger}
                                button
                                className='p-4px bg-white d-flex flex-row align-items-center'
                            >
                                <Dropdown.Menu>
                                    <Dropdown.Item>Sign Up</Dropdown.Item>
                                    <Dropdown.Item>Log In</Dropdown.Item>
                                    <Dropdown.Divider />
                                    <Dropdown.Item>Host your home</Dropdown.Item>
                                    <Dropdown.Item>Host an experience</Dropdown.Item>
                                    <Dropdown.Item>Help</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Menu.Item>
                    </Grid.Column>

                </Grid.Row>
                <Grid.Row className="p-0">
                    <Grid.Column>
                        <SearchBox />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Container>
    </Menu>
}
export default NavigationBar